// extracted by mini-css-extract-plugin
module.exports = {"headline":"X7Zn6","withSubtotalTitle":"_3syqR","totals":"_1q1PO","divider":"_3raX9"};